import useFetchList from '../../../elements/Hooks/useFetchList'
import useSelectionTable from '../../../elements/Hooks/useSelectionTable'
import useSubmit from '../../../elements/Hooks/useSubmit'
import React from 'react'
import SupplierRegistration from '../../../components/Purchasing/SupplierRegistration/SupplierRegistration'
import SupplierApi from '../../../api/Purchase/Suppliers'

function SupplierRegistrationCont (props) {
  const api = new SupplierApi()
  const { list, fetching, fetch } = useFetchList(api.registrations.list)

  const {
    tableRef,
    selection,
    selectAll,
    setSelection,
    toggleSelection,
    toggleAll,
    isSelected,
  } = useSelectionTable()

  const [removing, removeFunc] = useSubmit(api.registrations.remove, true)

  async function removeSelection () {
    const removed = await removeFunc([...selection])
    await fetch()
  }

  return (
    <SupplierRegistration
      {...{
        list,
        fetching,
        fetch,
        tableRef,
        selection,
        selectAll,
        setSelection,
        toggleSelection,
        toggleAll,
        isSelected,
        removeSelection,
        removing,
      }}
    />
  )
}

export default SupplierRegistrationCont
